<template>
  <div class="adm-toasts" role="status" aria-live="polite">
    <transition-group name="adm-toast">
      <div
        v-for="toast in toasts"
        :key="toast.id"
        class="adm-toast"
        :class="`adm-tone-${toast.tone}`"
      >
        <component :is="iconFor(toast.tone)" :size="18" class="adm-toast__icon" />
        <div class="adm-toast__body">
          <strong v-if="toast.title" class="adm-toast__title">{{ toast.title }}</strong>
          <span>{{ toast.message }}</span>
        </div>
        <button
          type="button"
          class="adm-toast__close"
          aria-label="Cerrar aviso"
          @click="dismiss(toast.id)"
        >
          <X :size="15" />
        </button>
      </div>
    </transition-group>
  </div>
</template>

<script>
/**
 * Contenedor de avisos. Se monta una sola vez, en `AdminLayout`; las vistas
 * no lo importan: llaman a `notify.*` del composable (plan §4.2, C10).
 */
import { CheckCircle2, AlertTriangle, XCircle, Info, X } from 'lucide-vue-next';
import { useAdmToast } from '@/composables/useAdmToast.js';

const ICONS = {
  ok: CheckCircle2,
  warn: AlertTriangle,
  danger: XCircle,
  info: Info,
};

export default {
  name: 'AdmToastHost',
  components: { X },
  setup() {
    const { toasts, dismiss } = useAdmToast();
    const iconFor = (tone) => ICONS[tone] || Info;
    return { toasts, dismiss, iconFor, X };
  },
};
</script>

<style scoped>
.adm-toasts {
  position: fixed;
  right: var(--adm-content-pad);
  bottom: var(--adm-content-pad);
  z-index: var(--adm-z-toast);
  display: flex;
  flex-direction: column;
  gap: var(--adm-gap-sm);
  max-width: min(380px, calc(100vw - 2 * var(--adm-content-pad)));
}

.adm-toast {
  display: flex;
  align-items: flex-start;
  gap: 0.6rem;
  padding: 0.75rem 0.9rem;
  border-radius: var(--adm-radius);
  box-shadow: var(--adm-shadow-lg);
  font-family: var(--font-body);
  font-size: var(--adm-font-sm);
  line-height: 1.35;
}

.adm-toast__icon { flex-shrink: 0; margin-top: 1px; }

.adm-toast__body {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
  min-width: 0;
}

.adm-toast__title { font-weight: 700; }

.adm-toast__close {
  flex-shrink: 0;
  padding: 0;
  background: none;
  border: none;
  color: inherit;
  opacity: 0.7;
  cursor: pointer;
}

.adm-toast__close:hover { opacity: 1; }

.adm-toast-enter-active,
.adm-toast-leave-active { transition: opacity 0.2s ease, transform 0.2s ease; }

.adm-toast-enter-from,
.adm-toast-leave-to { opacity: 0; transform: translateY(8px); }
</style>
